import * as actions from '../actions'

var defaultState = null

export default function subscription(state = defaultState, action) {
    switch (action.type) {

        case actions.SUBSCRIPTION_GET_ONE:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.SUBSCRIPTION_CLEAN_ONE:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/subscription.js